import { IntlMessageFormat } from 'intl-messageformat'
import type { Locale } from './locales'

export type MessageValues = Record<string, string | number | Date>

/** Formats the messages of one catalog in one locale. */
export type TranslateWith<K extends string> = (key: K, values?: MessageValues) => string

/**
 * A translator over one catalog (ICU MessageFormat messages) in one locale. Formatters are
 * compiled once and cached. Each surface brings its own catalog: the portal's (and the emails'),
 * or the back office's, so that neither bundle carries the other's texts.
 */
export function translatorFor<K extends string>(
  catalog: Readonly<Record<K, string>>,
  locale: Locale,
): TranslateWith<K> {
  const cache = new Map<K, IntlMessageFormat>()
  return (key, values) => {
    let formatter = cache.get(key)
    if (!formatter) {
      formatter = new IntlMessageFormat(catalog[key], locale)
      cache.set(key, formatter)
    }
    const result = formatter.format(values)
    return typeof result === 'string' ? result : String(result)
  }
}
